<template>
  <section class="header grey" aria-label="Lisa Corcoran">
    <header class="wrapper">
      <h1>Lisa Corcoran</h1>
      <span class="subtitle">Design & Development</span>
      <!-- <span class="desc">with Drupal and Javascript</span> -->
    </header>
  </section>

  <section id="porfolio" class="portfolio" aria-label="Work">
    <h2 class="visually-hidden">Work</h2>
    <div class="container grid">
      <PortfolioItem />
    </div>
  </section>

  <section id="about" class="about" aria-label="About me">
    <div class="wrapper">
      <h2>I contribute</h2>
      <ul>
        <li dir="ltr">Drupal theming and site building</li>
        <li dir="ltr">Component design and frontend design systems</li>
        <li dir="ltr">Accessibility and performance audits and remediation</li>
        <li dir="ltr">Testing and automated workflows</li>
        <li dir="ltr">Coordination between technical teams, design teams,
          stakeholders, as needed</li>
        <li dir="ltr">Project experience and proactive involvement in all steps
          from ideation to production and beyond</li>
        <li dir="ltr">Technical project management</li>
        <li dir="ltr">Technical strategy and project planning</li>
        <li dir="ltr">Partake in, or help establish, proactive documentation and
          communication processes to foster effective remote teams</li>
      </ul>
    </div>
  </section>


  <section class="cv">
    <div class="wrapper">
      <a href="https://www.emc23.com/sites/default/files/cv/LisaCorcoranCV2024.pdf"
        target="_blank" class="btn btn-cv"><span class="icon"></span>Download my CV
      </a>
    </div>
  </section>

  <section class="github">
    <div class="wrapper">
      <nav role="navigation" class="footer--social">
        <h2>On Github</h2>
        <ul class="menu">

          <!-- <li class="menu-item">
            <a href="https://github.com/EMC23">
              <img
                src="https://avatars.githubusercontent.com/u/6142164?s=200&amp;v=4"
                width="100" height="100" alt="@EMC23">
              <p>EMC23's Github</p>
            </a>
          </li> -->

          <li class="menu-item">
            <a href="https://github.com/left23">
              <img src="https://avatars.githubusercontent.com/u/1835923?v=4"
                width="100" height="100" alt="@left23">
              <p>Lisa's Github</p>
            </a>
          </li>

          <!-- <li class="menu-item">
            <a href="https://github.com/Techbot">
              <img src="https://avatars.githubusercontent.com/u/548643?v=4"
                width="100" height="100" alt="@Techbot">
              <p>Rob's Github</p>
            </a>
          </li> -->

        </ul>
      </nav>
    </div>
  </section>

  <div class="grey">
    <footer class="wrapper">
      <!-- <nav role="navigation" class="footer__nav">
        <ul class="menu">
          <li class="menu-item">
            <a href="https://www.emc23.com/taxonomy/term/25" class="active">Our
              Project<br>The Eclectic
              Meme Conspiracy</a>
          </li>
          <li class="menu-item">
            <a href="projects.html">Web design &amp;<br>development
              projects</a>
          </li>
          <li class="menu-item">
            <a href="experiments.html">Games &amp; code<br>experiments</a>
          </li>
          <li class="menu-item">
            <a href="http://emc23.com/blog">Our Blog<br>e=mc23</a>
          </li>
        </ul>
      </nav> -->
    </footer>
  </div>

</template>

<script>
import PortfolioItem from './components/PortfolioItem.vue'

export default {
  name: 'App',
  components: {
    PortfolioItem,
  },
  data() {
    return {

    }
  }
}
</script>

<style>
/* <uniquifier>: Use a unique and descriptive class name
<weight>: Use a value from 400 to 700 */
:root {
  --emc-white: #FFFFFF;
  --emc-white-off: #F5EFED;
  --emc-white-grey: #E8F1F2;
  --emc-grey-bg: #E6E6EA;
  --emc-grey-light: #E2E2E2;
  --emc-grey-mid: #605F5E;
  --emc-grey-dark: #363F3F;
  --emc-grey-dark-alt: #33312E;
  --emc-black: #0A0908;
  --emc-black-rich: #04151F;
  --emc-dark: #230007;
  --emc-teal-light: #00F2F2;
  --emc-teal-light-alt: #00B9AE;
  --emc-teal: #009999;
  --emc-teal-alt: #19535F;
  --emc-teal-dark: #000001;
  --emc-teal-dark-alt: #022B3A;
  --emc-teal-dark-rich: #042A2B;
  --emc-blue: #0A2463;
  --emc-green: #00CC66;
  --emc-yellow: #FFC43D;
  --emc-lime: #CEFF1A;
  --emc-red: #D00A01;
  --emc-pink: #EF476F;
  --emc-orange: #FB5012;
  --emc-purple: #3C1642;
}

.lora {
  font-family: "Lora", serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
}

.kanit-regular {
  font-family: "Kanit", sans-serif;
  font-weight: 400;
  font-style: normal;
}

.kanit-bold {
  font-family: "Kanit", sans-serif;
  font-weight: 700;
  font-style: normal;
}

body {
  margin: 0;
  padding: 0;
  background-color: white;
  color: #111;
  font: 16px;
  line-height: 1.5;
  font-family: "Kanit", sans-serif;
}
.container {
  max-width: 90%;
  text-align: center;
  margin: 0 auto;
}
a {
  color: var(--emc-black);
  text-decoration: none;
}
a:hover,
a:focus {
  text-decoration: underline;
}
h1,
h2 {
  font-family: "Kanit", sans-serif;
  font-optical-sizing: auto;
  font-weight: 700;
  font-style: normal;
  color: #111;
}
h3 {
  font-family: "Lora", serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: italic;
}
h1 {
  font-size: 2.5rem;
}
h2 {
  font-size: 2rem;
  color: var(--emc-teal-alt);
}
h2 a {
  color: var(--emc-teal-alt);
}
h2 a:hover {
  color: var(--emc-teal-alt);
  /* text-decoration: none; */
}
header h1 {
  margin: 0;
  padding: 5rem 0 1.75rem;
  color: var(--emc-grey-dark-alt);
}
header.wrapper {
  display: flex;
  align-items: baseline;
  flex-direction: column;
  padding-bottom: 2rem;
}

@media (min-width: 768px) {
  header.wrapper {
    align-items: baseline;
    flex-direction: row;
    padding-bottom: 0;
  }
}

header.wrapper > span {
  line-height: 2.5rem;
  margin-left: 1rem;
}

.header {
  border-bottom: 6px solid var(--emc-teal);
}

.portfolio {
  border-top: 4px solid var(--emc-lime);
  padding-top: 2rem;
}

.grey {
  background: var(--emc-white-off);
  background-image: url("data:image/svg+xml,<svg id='patternId' width='100%' height='100%' xmlns='http://www.w3.org/2000/svg'><defs><pattern id='a' patternUnits='userSpaceOnUse' width='40' height='40' patternTransform='scale(2) rotate(0)'><rect x='0' y='0' width='100%' height='100%' fill='hsla(0,0%,100%,1)'/><path d='M0 0l10 20L20 0H0zm10 20l10 20 10-20H10z'  stroke-width='1' stroke='none' fill='hsla(0, 5%, 96%, 1)'/><path d='M20 0l10 20L40 0zm10 20l10 20 10-20zm-40 0L0 40l10-20z'  stroke-width='1' stroke='none' fill='hsla(0, 0%, 98%, 1)'/></pattern></defs><rect width='800%' height='800%' transform='translate(0,0)' fill='url(%23a)'/></svg>")
}
@media (min-width: 768px) {
  .grid {
    display: grid;
    grid-gap: 2rem;
    grid-template-columns: repeat(auto-fit, minmax(1fr));
    grid-auto-columns: 1fr;
    grid-auto-flow: dense;
    padding: 2rem;
  }
}
@media (min-width: 1200px) {
  .grid {
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
    grid-auto-columns: 1fr;
    padding: 4rem 2rem;
    grid-gap: 3rem 6rem;
  }
}
.grid-item {
  /* background: rgba(0, 0, 0, 0.9); */
  /* box-shadow: 0 0 5px rgba(0, 0, 0, 0.1); */
  text-align: left;
  font-weight: 100;
  padding-bottom: 3rem;
}

@media (min-width: 768px) {
  .grid-item {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 1rem;
    align-content: start;
  }

  .grid-item.special + .grid-item {
    align-content: start;
  }
  .grid-item.special {
    grid-column: span 2;
    align-content: center;
    justify-content: center;
    /* grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 1fr); */
  }
  .grid-item.special img {
    grid-column: 1 / span 3;
    grid-row: 1 / span 2;
  }
  .grid-item.special .description {
    grid-column: 2 / span 3;
    /* grid-row: 1 / span 2; */
    /* padding: 2rem; */
    align-self: end;
    /* background: rgba(255, 255, 255, 0.8); */
    text-align: left;
  }
}
.grid-item img {
  width: 100%;
  margin: 0;
}
.grid-item .description {
  margin: 0;
  padding: 0 0 2rem;
}
.grid-item h2 {
  line-height: 1.2;
}
.grid-item .description {
  border-bottom: var(--emc-lime) 6px solid;
}
/* .grid-item.special .description,
.grid-item.special + .grid-item .description {
  border-top: var(--emc-lime) 6px solid;
  border-bottom: 0 none;
} */
.subtitle {
  font-family: 'Lora';
  font-size: 1.8rem;
  font-style: italic;
  color: var(--emc-grey-dark-alt);
}

header,
nav,
.wrapper {
  margin: 0 auto;
}
.about .wrapper {
  padding: 3rem;
  background: var(--emc-teal-dark-alt);
}
footer.wrapper {
  padding: 2rem 0 3rem;
}
.wrapper  {
  padding: 0 2rem;
}

.about {
  background: var(--emc-teal-dark-alt);
  color: var(--emc-white-off);
  font-size: 150%;
  background-image: url("data:image/svg+xml,<svg id='patternId' width='100%' height='100%' xmlns='http://www.w3.org/2000/svg'><defs><pattern id='a' patternUnits='userSpaceOnUse' width='40' height='40' patternTransform='scale(2) rotate(0)'><rect x='0' y='0' width='100%' height='100%' fill='hsla(196, 93%, 12%, 1)'/><path d='M0 0l10 20L20 0H0zm10 20l10 20 10-20H10z'  stroke-width='1' stroke='none' fill='hsla(190, 61%, 17%, 1)'/><path d='M20 0l10 20L40 0zm10 20l10 20 10-20zm-40 0L0 40l10-20z'  stroke-width='1' stroke='none' fill='hsla(190, 54%, 20%, 1)'/></pattern></defs><rect width='800%' height='800%' transform='translate(0,0)' fill='url(%23a)'/></svg>")
}

.about h2 {
  color: var(--emc-white-off);
  /* margin-top: 5rem; */
}
.about a {
  color: var(--emc-white-off);
}

.github {
  background: var(--emc-teal);
  color: var(--emc-white-off);
}

.github h2 {
  color: var(--emc-white-off);
  text-align: center;
  /* margin-top: 5rem; */
}
.github a {
  display: inline-block;
  color: var(--emc-white-off);
}

.cv {
  background: var(--emc-teal-dark);
  color: var(--emc-white-off);
  padding: 6rem 0 8rem;
  text-align: center;
}
.cv a {
  background: var(--emc-teal-dark-alt);
  color: var(--emc-white-off);
}

@media (min-width: 1200px) {
  .wrapper {
    max-width: 1136px;
  }
  .about .wrapper {
    max-width: 866px;
  }
}

nav ul {
  list-style-type: none;
  text-align: center;
  padding: 0;
  margin-left: 0;
}

@media (min-width: 481px) {
  nav ul {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
  }
}

ul.menu {
  list-style: none outside;
  margin: 0;
  padding: 0;
}

nav ul li {
  display: block;
}

@media (min-width: 481px) {
  nav ul li {
    flex: 1 1 50%;
  }
}

@media (min-width: 768px) {
  nav ul li {
    flex: 1 1 0;
  }
}

nav ul>li>a {
  color: var(--emc-purple);
  text-decoration: none;
}

nav ul>li>a:hover {
  color: var(--emc-teal-alt);
}

nav ul>li>a {
  display: block;
  padding: 0.5rem 0;
}

.btn {
  padding: 0.75rem 2rem;
  align-items: center;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  line-height: 1.25;
  position: relative;
  text-decoration: none;
  transition: all 250ms;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: baseline;
  width: auto;
}

.btn-demo {
  color: white;
  background-color: #FFFFFF;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: .25rem;
  box-shadow: rgba(0, 0, 0, 0.02) 0 1px 3px 0;
  box-sizing: border-box;
  color: rgba(0, 0, 0, 0.85);
  cursor: pointer;
  text-decoration: none;
  transition: all 250ms;
}

.btn-demo:hover,
.btn-demo:focus {
  border-color: rgba(0, 0, 0, 0.15);
  box-shadow: rgba(0, 0, 0, 0.1) 0 4px 12px;
  color: rgba(0, 0, 0, 0.65);
  text-decoration: none;
}

.btn-demo:hover {
  transform: translateY(-1px);
}

.footer--social {
  padding: 3rem 0 5rem;
}

.footer--social li a img {
  background-color: #FFFFFF;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 100%;
  border-color: rgba(0, 0, 0, 0.15);
    box-shadow: rgba(0, 0, 0, 0.1) 0 4px 12px;
    color: rgba(0, 0, 0, 0.65);
}

.visually-hidden {
  position: absolute !important;
  clip: rect(1px, 1px, 1px, 1px);
  overflow: hidden;
  height: 1px;
  width: 1px;
  word-wrap: normal;
}



</style>
